import { Stack, Typography, useTheme } from '@mui/material';

import { Link01Icon } from '@/components/icons/Link01Icon';
import { COLORS } from '@/styles/tokens/colors';

export interface AssetProviderLinkIndicatorProps {
  providerName: string;
}

export function AssetProviderLinkIndicator({
  providerName,
}: AssetProviderLinkIndicatorProps) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Link01Icon
        size={16}
        color={isDark ? COLORS.NAVY[300] : COLORS.NAVY[700]}
      />
      <Stack direction="row" alignItems="baseline" spacing={1}>
        <Typography
          variant="title-s"
          color={isDark ? COLORS.NAVY[300] : undefined}
          component="div"
        >
          Data link
        </Typography>
        <Typography variant="body-xs" component="div">
          {providerName}
        </Typography>
      </Stack>
    </Stack>
  );
}
